import {defineStore} from 'pinia'
import api from '@/services/api'
import {useItemDataStore} from '@/stores/itemData'

export const usePagesStore = defineStore('pages', {
    state: () => ({
        classNames: undefined,
        pageIds: undefined
    }),
    actions: {
        async init() {
            if (this.pageIds === undefined) {
                this.pageIds = []
                
                const response = await api.get('api/component/pages/id')
                const pageIds = response.data.values
                
                this.pageIds = pageIds
                
                const itemDataStore = useItemDataStore()
                await itemDataStore.preload({tableName: 'pages', ids: pageIds})
            }
            
            return this.pageIds
        },
        async getClassNames({refresh} = {}) {
            if (this.classNames === undefined || refresh) {
                this.classNames = []
                
                const response = await api.get('api/component/pages/class', {
                    params: {groupBy: 'class', sort: 'class'}
                })
                
                this.classNames = (response.data.values || []).filter(Boolean)
            }
            
            return this.classNames
        }
    }
})